import type { Platform } from '@auto-oms/shared/types/order';

const STYLE: Record<Platform, { label: string; className: string }> = {
  NAVER:     { label: '네이버', className: 'bg-brand-50 text-brand-700' },
  COUPANG:   { label: '쿠팡',   className: 'bg-info-soft text-info-ink' },
  COUPANG_R: { label: '쿠팡R',  className: 'bg-[#E0F2FE] text-[#075985]' },
  LM:        { label: 'LM',     className: 'bg-[#EDE9FE] text-[#5B21B6]' },
};

// NAVER/COUPANG은 platform 자체가 채널이므로 lumi_code.channel_name 으로 덮어쓰지 않는다.
// LM/COUPANG_R 만 한 platform 아래 여러 표시명을 갖기 때문에 channelName 을 우선 노출.
const CHANNEL_NAME_OVERRIDE: Record<Platform, boolean> = {
  NAVER: false,
  COUPANG: false,
  COUPANG_R: true,
  LM: true,
};

export function ChannelBadge({
  platform,
  channelName,
}: {
  platform: Platform;
  channelName?: string | null;
}) {
  const s = STYLE[platform];
  const label =
    CHANNEL_NAME_OVERRIDE[platform] && channelName?.trim() ? channelName.trim() : s.label;
  return <span className={`badge ${s.className}`}>{label}</span>;
}
